<template>
  <Menu
    mode="horizontal"
    theme="light"
    active-name="1"
    ref="menu"
  >
    <template v-for="oneMenu in menus">
      <template
        class="one-submenu"
        v-if="oneMenu.children"
      >
        <Submenu
          :name="oneMenu.name"
          :key="oneMenu.name"
          :to="oneMenu.to"
        >
          <span slot="title" @click="navTo(oneMenu.to)">
            <i class="iconfont" :class="oneMenu.icon"></i>
            <!-- <span>{{oneMenu.title}}</span> -->
            <Badge :count="oneMenu.notice || undefined" class-name="notice">
              <span>{{ oneMenu.title }}</span>
            </Badge>
          </span>
          <template v-for="item in oneMenu.children">
            <MenuGroup
              v-if="item.type == 'menuGroup'"
              :title="item.title"
              :key="item.title"
            >
              <MenuItem
                v-for="oneMenuGroupItem in item.children"
                :key="oneMenuGroupItem.name"
                :name="oneMenuGroupItem.name"
                :to="oneMenuGroupItem.to"
              >
                <i class="iconfont" :class="oneMenuGroupItem.icon"></i>
                <Badge
                  :count="oneMenuGroupItem.notice || undefined"
                  class-name="notice"
                >
                  <span>{{ oneMenuGroupItem.title }}</span>
                </Badge>
              </MenuItem>
            </MenuGroup>

            <MenuItem v-else :key="item.name" :name="item.name" :to="item.to">
              <i class="iconfont" :class="item.icon"></i>
              <Badge :count="item.notice || undefined" class-name="notice">
                <span>{{ item.title }}</span>
              </Badge>
            </MenuItem>
          </template>
        </Submenu>
      </template>

      <MenuItem
        v-else
        :key="oneMenu.name"
        :name="oneMenu.name"
        :to="oneMenu.to"
      >
        <i class="iconfont" :class="oneMenu.icon"></i>
        <Badge :count="oneMenu.notice || undefined" class-name="notice">
          <span>{{ oneMenu.title }}</span>
        </Badge>
      </MenuItem>
    </template>
  </Menu>
</template>
<script>
export default {
  data() {
    return {
      menus: [],
      auth: [],
    };
  },
  methods: {
    init() {
      this.menus = [
        {
          to: "/home",
          name: "/home",
          title: "首页",
          icon: "icon-home",
        },
        {
          to: "/student",
          name: "/student",
          title: "学生信息",
          icon: "icon-team",
          // children: [
          //   {
          //     to: "/student/info_person",
          //     title: "个人信息",
          //     name: "/student/info_person",
          //   },
          //   {
          //     to: "/student/info_home",
          //     title: "家庭信息",
          //     name: "/student/info_home",
          //   },
          //   {
          //     to: "/student/info_education",
          //     title: "教育信息",
          //     name: "/student/info_education",
          //   },
          //   {
          //     to: "/student/info_account",
          //     title: "账号信息",
          //     name: "/student/info_account",
          //   },
          // ],
        },
        {
          to: "/planning/overview",
          name: "/planning/overview",
          title: "规划面板",
          icon: "icon-team",
          children: [
            // {
            //   to: "/planning/overview",
            //   title: "总览",
            //   name: "/planning/overview",
            // },
            {
              type: "menuGroup",
              title: "规划日程",
              children: [
                // {
                //   to: "/planning/planning_circuit",
                //   title: "线路图",
                //   name: "/planning/planning_circuit",
                // },
                {
                  to: "/planning/planning_general_view",
                  title: "总视图",
                  name: "/planning/planning_general_view",
                },
                {
                  to: "/planning/planning_month_view",
                  title: "月视图",
                  name: "/planning/planning_month_view",
                },
              ],
            },
            {
              type: "menuGroup",
              title: "学术",
              children: [
                {
                  to: "/planning/planning_language",
                  title: "语言",
                  name: "/planning/planning_language",
                },
                {
                  to: "/planning/planning_gpa",
                  title: "GPA",
                  name: "/planning/planning_gpa",
                },
                {
                  to: "/planning/planning_standardization",
                  title: "标化",
                  name: "/planning/planning_standardization",
                },
                {
                  to: "/planning/planning_reading",
                  title: "阅读",
                  name: "/planning/planning_reading",
                },
              ],
            },
            {
              type: "menuGroup",
              title: "背景提升",
              children: [
                {
                  to: "/planning/planning_competition",
                  title: "竞赛",
                  name: "/planning/planning_competition",
                },
                {
                  to: "/planning/planning_activity",
                  title: "活动",
                  name: "/planning/planning_activity",
                },
              ],
            },
          ],
        },
        {
          to: "/apply/apply_schoolSelection",
          name: "/apply/apply_schoolSelection",
          title: "申请面板",
          icon: "icon-shenqing",
          children: [
            {
              type: "menuGroup",
              title: "选校",
              children: [
                // {
                //   to: "/apply/apply_schoolSelection",
                //   title: "选校列表",
                //   name: "/apply/apply_schoolSelection",
                // },
                {
                  to: "/apply/apply_materials",
                  title: "申请材料",
                  name: "/apply/apply_materials",
                },
              ],
            },

            {
              type: "menuGroup",
              title: "文书",
              children: [
                {
                  to: "/apply/apply_ps",
                  title: "文书",
                  name: "/apply/apply_ps",
                },
              ],
            },

            {
              type: "menuGroup",
              title: "送分",
              children: [
                {
                  to: "/apply/apply_language",
                  title: "语言",
                  name: "/apply/apply_language",
                },
                {
                  to: "/apply/apply_standardization",
                  title: "标化",
                  name: "/apply/apply_standardization",
                },
              ],
            },
            {
              type: "menuGroup",
              title: "面试",
              children: [
                {
                  to: "/apply/apply_interview",
                  title: "面试",
                  name: "/apply/apply_interview",
                },
              ],
            },
          ],
        },
        {
          to: "/school-admin/list",
          name: "/school-admin/list",
          title: "学校管理",
          icon: "icon-school",
        },
        {
          to: "/teacher",
          name: "/teacher",
          title: "管理老师",
          icon: "icon-setting",
        },
      ];
    },

    navTo(url) {
      this.$router.push({
        path: url
      })
    },

  },
  mounted() {
    this.init();
  },
  watch: {
    $route() {
      // this.openNames = [];
      // this.openNames.push('/' + this.$route.path.split('/')[1]);
      // this.$nextTick(() => {
      //   this.$refs['menu'].updateOpened()
      // })
      // this.activeName = this.$route.path;
    },
  },
};
</script>
<style lang="less" scoped>
.notice {
  top: 0px !important;
  right: -20px !important;
}

.iconfont {
  font-size: 18px;
}
</style>